import React from 'react';
import Typography from '../atoms/Typography';
import Button from '../atoms/Button';
import ChevronRightIcon from '../atoms/ChevronRightIcon';
import { useNavigate } from "react-router-dom";

/**
 * Card footer molecule — "Updated on…" text + Configure button.
 */
export default function CardFooter({
  updatedOn,
  openLabel = 'Open',
  configureLabel = 'Configure',
  onOpen,
  onConfigure,
  className = '',
  id,
  title,
}) {

  const navigate = useNavigate();

const onOpenClick = () => {

  // navigate(`/query-management/${id}`, { state: { title } });
  navigate(`/querymanagement`);
}

  return (
    <div className={`ca-system-card__footer ${className}`.trim()}>
      <Typography variant="small" as="span">
        {updatedOn ? `Updated on ${updatedOn}` : ''}
      </Typography>
      <div className="ca-system-card__footer-actions">
        <Button size="sm" onClick={onOpenClick}>
          {openLabel}
        </Button>
        <Button
          variant="outline"
          size="sm"
          onClick={onConfigure}
          endIcon={<ChevronRightIcon size={14} color="currentColor" />}
        >
          {configureLabel}
        </Button>
      </div>
    </div>
  );
}
